import { render, staticRenderFns } from "./GanttGrid.vue?vue&type=template&id=0cf7d854&scoped=true&lang=pug&"
import script from "./GanttGrid.vue?vue&type=script&lang=js&"
export * from "./GanttGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cf7d854",
  null
  
)

export default component.exports